export default {"src":"/_next/static/media/0x0d8ce2a99bb6e3b7db580ed848240e4a0f9ae153.40406401.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};